import useQuery from '../../../../ReactQuery/useQuery';
import { get } from '../../../../redux/api';
import type {
  ListRepositoriesParams,
  ListRepositoriesResponse,
} from '../../../../../shared/types/routes/vcs/githubApp';
import type { VcsApp } from '../../../../../shared/vcs/githubApp/apps';

const fetchGitHubAppRepositories = (app: VcsApp, { page, pageSize, q, connectionId }: ListRepositoriesParams) =>
  get<ListRepositoriesResponse>(`/api/vcs/github-apps/${app}/repositories`, false, {
    page,
    pageSize,
    q,
    connectionId,
  });

export const getGitHubAppRepositoriesQueryKeyPrefix = (app: VcsApp) =>
  ['vcs', 'github-apps', app, 'repositories'] as const;

export const getGitHubAppRepositoriesQueryKey = (app: VcsApp, params: ListRepositoriesParams) =>
  [...getGitHubAppRepositoriesQueryKeyPrefix(app), params] as const;

/**
 * Lists a page of repositories for the org's `app` connection, with server-side pagination
 * and name search (mirroring the legacy import flow, loader between pages included).
 * Pass `enabled: false`: before the app is installed, hold the request until the org has a connection.
 */
export function useGitHubAppRepositories(
  app: VcsApp,
  params: ListRepositoriesParams,
  { enabled = true }: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: getGitHubAppRepositoriesQueryKey(app, params),
    queryFn: () => fetchGitHubAppRepositories(app, params),
    enabled,
  });
}
